/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A company-scoped folder used to group claims (e.g. by contracting company).
 * @export
 * @interface ClaimFolder
 */
export interface ClaimFolder {
    /**
     * Unique folder ID
     * @type {number}
     * @memberof ClaimFolder
     */
    readonly id: number;
    /**
     * ID of the company this folder belongs to
     * @type {number}
     * @memberof ClaimFolder
     */
    companyId: number;
    /**
     * Folder name
     * @type {string}
     * @memberof ClaimFolder
     */
    name: string;
    /**
     * Optional hex color code for folder display (e.g., "#3B82F6")
     * @type {string}
     * @memberof ClaimFolder
     */
    color?: string | null;
    /**
     * Number of claims assigned to this folder (only present when requested)
     * @type {number}
     * @memberof ClaimFolder
     */
    readonly claimCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimFolder
     */
    readonly createdBy: number;
    /**
     * 
     * @type {Date}
     * @memberof ClaimFolder
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ClaimFolder
     */
    readonly updatedAt: Date;
}

/**
 * Check if a given object implements the ClaimFolder interface.
 */
export function instanceOfClaimFolder(value: object): value is ClaimFolder {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function ClaimFolderFromJSON(json: any): ClaimFolder {
    return ClaimFolderFromJSONTyped(json, false);
}

export function ClaimFolderFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimFolder {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'name': json['name'],
        'color': json['color'] == null ? undefined : json['color'],
        'claimCount': json['claimCount'] == null ? undefined : json['claimCount'],
        'createdBy': json['createdBy'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function ClaimFolderToJSON(json: any): ClaimFolder {
    return ClaimFolderToJSONTyped(json, false);
}

export function ClaimFolderToJSONTyped(value?: Omit<ClaimFolder, 'id'|'claimCount'|'createdBy'|'createdAt'|'updatedAt'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companyId': value['companyId'],
        'name': value['name'],
        'color': value['color'],
    };
}

